/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { AsyncComponent } from '../../components/AsyncComponent';
import { ContentAnnotationList } from '../../components/ContentAnnotationList';
import { DefaultContentListItemPlaceholder } from '../../components/DefaultContentListItem/DefaultContentListItemPlaceholder';
import { NoResultsFoundMessage } from '../../components/NoResultsFoundMessage';
import { SearchResultItemRenderer } from '../../components/SearchResultItemRenderer';
import { SearchInput } from '../../components/_inputs/SearchInput';
import { Title } from '../../components/_shell/Title';
import { ContentWithTitleTemplate } from '../../components/_templates/ContentWithTitleTemplate';
import { useReturnUrlFromPdf } from '../../Hooks/useReturnUrlFromPdf';
import { queryStringParser } from '../../util/QueryStringParser';
import { Pagination } from '../pesquisa/components/Pagination';
import { useAnnotationsState } from './hooks/useAnnotationsState';

export const AnnotationListPage = (props: RouteComponentProps) => {
  const { state, getAnnotations } = useAnnotationsState();
  const { returnToHereFromPdf } = useReturnUrlFromPdf();
  const history = useHistory();
  const words = useRef('');
  const page: number = Number(_.get(props.match.params, 'page')) || 1;
  const queryString: any = queryStringParser.fromQueryString(location.search);
  const [textToSearch, setTextToSearch] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    if (words.current !== queryString.words) {
      words.current = queryString.words;

      setTextToSearch(queryString.words);

      returnToHereFromPdf();

      getAnnotations(page, queryString.words, controller.signal);
    }
    return () => {
      controller.abort();
    };
  }, [location.search]);

  useEffect(() => {
    getAnnotations(page);
    returnToHereFromPdf();
  }, [page]);

  return (
    <ContentWithTitleTemplate
      TitleContent={<Title key="1">Minhas anotações</Title>}
      Content={
        <Container>
          <ClippingSearchContainer>
            <SearchInput
              labelText="Pesquisar nas anotações:"
              doSearch={(textInput: string) => {
                const search = queryStringParser.toQueryString({
                  words: textInput
                });

                history.push(`/anotacoes/1?${search}`);
              }}
              onChange={setTextToSearch}
              value={textToSearch}
            />
            <span>Ordenado por data (decrescente)</span>
          </ClippingSearchContainer>

          <AsyncComponent
            error={state.requestProgress.error}
            loading={state.requestProgress.loading}
            renderPlaceholder={() => (
              <div style={{ width: '100%' }}>
                <DefaultContentListItemPlaceholder
                  style={{ marginBottom: '2rem' }}
                />
                <DefaultContentListItemPlaceholder
                  style={{ marginBottom: '2rem' }}
                />
                <DefaultContentListItemPlaceholder
                  style={{ marginBottom: '2rem' }}
                />
              </div>
            )}
            renderContent={() => (
              <>
                {!!(state.total === 0) && (
                  <NoResultsFoundMessage message="Você ainda não possui anotações" />
                )}

                <Ul>
                  {(state.annotations || []).map((contentAnnotations) => {
                    if (
                      String(contentAnnotations.content.img).includes(
                        '/books/cover'
                      )
                    ) {
                      const stage = process.env.REACT_APP_STAGE || 'staging';
                      contentAnnotations.content.img = `https://bid1006-${stage}-public.s3.sa-east-1.amazonaws.com${contentAnnotations.content.img}`;
                    }
                    return (
                      <SearchResultItemRenderer
                        result={contentAnnotations.content}
                        key={`groupAnnotationsByContent_${contentAnnotations.content.id}`}
                        otherProps={{
                          className: 'content-item',
                          Content: (
                            <ContentAnnotationList
                              annotations={contentAnnotations.annotations}
                            />
                          )
                        }}
                      />
                    );
                  })}
                </Ul>

                {/* <Ul>
                  {(state.annotations || [])
                    .filter((contentAnnotations) => {
                      const annotations = contentAnnotations.annotations;

                      // Garante que é array e tem pelo menos 1 item
                      if (
                        Array.isArray(annotations) &&
                        annotations.length > 0
                      ) {
                        const allInvalid = annotations.every(
                          (ann) =>
                            ann &&
                            typeof ann.text === 'string' &&
                            ann.text.includes('[object Object]')
                        );

                        return !allInvalid;
                      }

                      return true; // se não for array ou estiver vazio, mantém
                    })
                    .map((contentAnnotations) => {
                      if (
                        String(contentAnnotations.content.img).includes(
                          '/books/cover'
                        )
                      ) {
                        const stage = process.env.REACT_APP_STAGE || 'staging';
                        contentAnnotations.content.img = `https://bid1006-${stage}-public.s3.sa-east-1.amazonaws.com${contentAnnotations.content.img}`;
                      }

                      return (
                        <SearchResultItemRenderer
                          result={contentAnnotations.content}
                          key={`groupAnnotationsByContent_${contentAnnotations.content.id}`}
                          otherProps={{
                            className: 'content-item',
                            Content: (
                              <ContentAnnotationList
                                annotations={contentAnnotations.annotations}
                              />
                            )
                          }}
                        />
                      );
                    })}
                </Ul> */}

                {/* 
                <Ul>
                  {(state.annotations || [])
                    .filter((contentAnnotations) => {
                      const annotations = contentAnnotations.annotations;

                      const hasOnlyOneInvalidAnnotation =
                        Array.isArray(annotations) &&
                        annotations.length === 1 &&
                        annotations[0] &&
                        typeof annotations[0].text === 'string' &&
                        annotations[0].text.includes('[object Object]');

                      return !hasOnlyOneInvalidAnnotation;
                    })
                    .map((contentAnnotations) => {
                      if (
                        String(contentAnnotations.content.img).includes(
                          '/books/cover'
                        )
                      ) {
                        const stage = process.env.REACT_APP_STAGE || 'staging';
                        contentAnnotations.content.img = `https://bid1006-${stage}-public.s3.sa-east-1.amazonaws.com${contentAnnotations.content.img}`;
                      }

                      return (
                        console.log(
                          contentAnnotations.annotations,
                          ' : contentAnnotations.annotations : ',
                          contentAnnotations.annotations.length,
                          contentAnnotations.annotations[0].text,
                          ' : contentAnnotations.annotations[0].text',
                          contentAnnotations.annotations[0].text.includes(
                            '[object Object]'
                          )
                        ),
                        (
                          <SearchResultItemRenderer
                            result={contentAnnotations.content}
                            key={`groupAnnotationsByContent_${contentAnnotations.content.id}`}
                            otherProps={{
                              className: 'content-item',
                              Content: (
                                <ContentAnnotationList
                                  annotations={contentAnnotations.annotations}
                                />
                              )
                            }}
                          />
                        )
                      );
                    })}
                </Ul> */}

                <PaginationContainer>
                  <Pagination
                    {...{
                      onChange: (page: number) =>
                        props.history.push(`/anotacoes/${page}`),
                      currentPage: page,
                      total: state.total,
                      pageSize: 20
                    }}
                  />
                </PaginationContainer>
              </>
            )}
          />
        </Container>
      }
    />
  );
};

const Container = styled.div`
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ClippingSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 1rem;
  align-items: center;
  margin-bottom: 2rem;
`;

const PaginationContainer = styled.div`
  padding: 2rem 0;
`;

const Ul = styled.ul`
  width: 100%;

  li.content-item {
    margin-bottom: 5rem;
  }
`;
